const MIN_PASSWORD_LENGTH = 8;

export function validatePassword(password, confirmPassword) {
  const errors = [];
  if (!password || password.length < MIN_PASSWORD_LENGTH) {
    errors.push(`Password must be at least ${MIN_PASSWORD_LENGTH} characters`);
  }
  if (confirmPassword !== undefined && password !== confirmPassword) {
    errors.push('Passwords do not match');
  }
  return errors;
}

export function isPasswordValid(password) {
  return Boolean(password && password.length >= MIN_PASSWORD_LENGTH);
}

export { MIN_PASSWORD_LENGTH };
